import { CreateTxOptions, MsgExecuteContract } from '@terra-money/terra.js'
import { contractAddresses } from 'constants/address'
import { defaultNetworkName } from 'constants/network'
import { GatewayConfig } from 'interfaces/gateway.interface'
import { BaseLcdService } from './base/baseLcdService'

class GatewayService extends BaseLcdService {
  private pilotGateway: string

  constructor() {
    super()
    this.pilotGateway = contractAddresses[defaultNetworkName].pilotGateway
  }

  initAddress = (pilotGateway: string) => {
    this.pilotGateway = pilotGateway
  }

  get pilotGatewayAddress() {
    return this.pilotGateway
  }

  getConfig = async () => {
    const msg = {
      config: {},
    }
    const response = await this.contractQuery<GatewayConfig>(
      this.pilotGateway,
      msg,
    )
    return response
  }

  getWhitelistStatus = async (address: string) => {
    const msg = {
      whitelist_status: {
        address,
      },
    }
    const response = await this.contractQuery<boolean>(this.pilotGateway, msg)
    return response
  }

  getSlotWhitelisted = async (address: string) => {
    const msg = {
      slot_whitelisted: {
        address,
      },
    }
    const response = await this.contractQuery<number>(this.pilotGateway, msg)
    return response
  }

  invite = (senderAddr: string, address: string): CreateTxOptions => {
    const msg = {
      invite: {
        address,
      },
    }

    return {
      msgs: [new MsgExecuteContract(senderAddr, this.pilotGateway, msg)],
    }
  }
}

export const gatewayService = new GatewayService()
